/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import Assert from "../../../../Basis/Utils/Assert";
import StripeKontoClient, { Konto } from "../../../../Management/Mandanten/Api/StripeKontoClient";
import { Schritt } from "../../Queries/Schnelleinstieg";
import { QueryResult } from "./utils";

type WeiterButtonProps = {
    onClick: () => Promise<unknown>;
    disabled?: boolean;
}

type SchnelleinstiegContextValue = {
    start: () => void;
    ueberspringen: () => void;
    istDurchgefuehrt: (schritt: Schritt) => boolean;
    aktuellerSchritt?: Schritt
    naechsterSchritt?: Schritt
    WeiterButton: (props: WeiterButtonProps) => React.ReactElement<WeiterButtonProps>;
    stripe: {
        kontoResult: QueryResult<Konto | null>,
        service: StripeKontoClient,
    };
}

const SchnelleinstiegContext = React.createContext<SchnelleinstiegContextValue | null>(null);

export const SchnelleinstiegContextProvider = SchnelleinstiegContext.Provider;

export function useSchnelleinstiegContext() {
    const context = React.useContext(SchnelleinstiegContext);
    return Assert.notNull(context, "useSchnelleinstiegContext kann nur innerhalb des SchnelleinstiegContextProviders verwendet werden!");
}